import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

const Home = () => {
    return <Redirect to='/dms/file-explorer' />
}

export default connect()(Home);
